import React from 'react';
import Card from '../ui/Card';
import { typography } from '../../design-system/tokens';

function formatWeekRange(weekStartAt, weekEndAt) {
  if (!weekStartAt || !weekEndAt) return null;
  const start = new Date(weekStartAt);
  const end = new Date(weekEndAt - 1);
  const sameMonth = start.getUTCMonth() === end.getUTCMonth();
  const startLabel = start.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
  const endLabel = end.toLocaleDateString(undefined, {
    month: sameMonth ? undefined : 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
  return `${startLabel} – ${endLabel}`;
}

export default function WeeklyChampionCard({
  weeklyChampion,
  weekStartAt,
  weekEndAt,
  loading = false,
}) {
  const weekLabel = formatWeekRange(weekStartAt, weekEndAt);

  return (
    <Card
      variant="admin"
      className="p-4 border-amber-500/30 bg-gradient-to-br from-amber-500/10 via-black/40 to-black/60"
    >
      <p className={`${typography.microWide} text-amber-300 mb-1`}>Weekly champion</p>
      {weekLabel && (
        <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2">
          {weekLabel} · UTC
        </p>
      )}

      {loading && (
        <p className="text-sm text-gray-500 font-bold">Loading weekly leader…</p>
      )}

      {!loading && weeklyChampion && (
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="text-xl font-black text-white">
              👑 {weeklyChampion.displayName || 'Player'}
            </p>
            <p className="text-sm text-gray-300 font-bold mt-1 tabular-nums">
              {weeklyChampion.wins ?? 0}-{weeklyChampion.losses ?? 0}
              {(weeklyChampion.currentStreak ?? 0) > 0 && (
                <span className="text-amber-400 ml-2">
                  🔥 {weeklyChampion.currentStreak}W
                </span>
              )}
            </p>
            {(weeklyChampion.locksCompleted ?? 0) > 0 && (
              <p className="text-xs text-gray-500 font-medium mt-1">
                {weeklyChampion.locksCompleted} lock
                {weeklyChampion.locksCompleted === 1 ? '' : 's'} this week
              </p>
            )}
          </div>
        </div>
      )}

      {!loading && !weeklyChampion && (
        <p className="text-sm text-gray-400 font-medium leading-relaxed">
          No weekly leader yet — post the first lock.
        </p>
      )}
    </Card>
  );
}
